import React, { PureComponent } from 'react';
import { Form } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { SemanticFormField } from './SemanticFormField';
import { getValidations } from '../helpers/validationByFieldType';

// components

class TermsOfService extends PureComponent {
  render() {
    return (
      <Form>
        <Field
          name="termsOfService"
          label="I agree to the Terms of Service."
          component={SemanticFormField}
          as={Form.Checkbox}
          validate={getValidations(true)}
        />
      </Form>
    );
  }
}

export default reduxForm({ destroyOnUnmount: false })(TermsOfService);



// WEBPACK FOOTER //
// ./src/components/TermsOfService.js